import {
  addDDRumGlobalContext,
  observabilityPlugin
} from '@/plugins/observability'

import { EventData, LogLevel, ProviderConfig, User } from '../../models'
import { eventFormatter } from '../../utils/eventFormatter'
import AbstractProvider from '../AbstractProvider'

export default class DatadogProvider implements AbstractProvider {
  public identify(userId: string, traits: User): void {
    const emailDomain = traits?.email?.split('@')[1]

    const data = {
      id: userId,
      permissions: traits?.permissions,
      role: traits?.role,
      emailDomain
    }
    addDDRumGlobalContext(data)
  }

  public log(
    eventName: string,
    eventData: EventData,
    config?: ProviderConfig
  ): void {
    const logData = eventFormatter(eventData)

    if (!config) {
      this.addAction(eventName, logData)
      return
    }

    if (config.logLevel === LogLevel.ERROR) {
      if (config.isAction) {
        this.adActionError(new Error(eventName), logData)
        return
      }
      this.addLogError(eventName, logData)
      return
    }

    if (config.isAction) {
      this.addAction(eventName, logData)
      return
    }
    this.addLogInfo(eventName, logData)
  }

  /**
   * Add new action event
   * @param eventName
   * @param eventData
   */
  private addAction(eventName: string, eventData: object): void {
    observabilityPlugin?.addAction(eventName, eventData)
  }
  /**
   * Add new error event
   * @param error
   * @param context
   */
  private adActionError(error: Error, context: object): void {
    observabilityPlugin?.addError(error, context)
  }
  /**
   * Add info log
   * @param eventName
   * @param eventData
   */
  private addLogInfo(eventName: string, eventData: object): void {
    observabilityPlugin?.logger.info(eventName, eventData)
  }
  /**
   * Add error log
   * @param eventName
   * @param eventData
   */
  private addLogError(eventName: string, eventData: object): void {
    observabilityPlugin?.logger.error(eventName, eventData)
  }
}
